/* eslint no-console: 0 */
export default {
  init() {
    $(document).ready(() => {
      $('#datepicker').datepicker({
        dateFormat: 'yy-mm-dd',
        dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        firstDay: 7,
        beforeShowDay: (date) => {
          let formattedDate = $.datepicker.formatDate('yy-mm-dd', date);
          if (window.EOEventDates.indexOf(formattedDate) !== -1) {
            return [true, 'has-event', ''];
          }
          return [false, '', ''];
        },
        onSelect: (selectedDate) => {
          const $events = $('.events-list__row');
          $.each($events, (i) => {
            const $event = $events.eq(i);
            const eventDate = $event.data('event-date');
            if (eventDate !== selectedDate) {
              $event.hide();
            } else {
              $event.show();
            }
          });
        },
      });

      // Don't show past events in the calendar list of upcoming events,
      // unless they get selected.
      this.hidePastEvents();

      // Initialize the twitter slider
      this.initSlickSlider();

      //Initialize Hero Slider
      this.initHeroSlider();

      //On load of home show Quicklinks by default
      $(document).ready(() => {
        $('.mega-menu-item.mega-menu-item--quicklinks').addClass('quicklinks-trigger--open');
        $('.quicklinks-wrapper').addClass('quicklinks-wrapper--open');
      });

    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
  hidePastEvents() {
    const $events = $('.events-list__row');
    const d = new Date();
    $.each($events, (i) => {
      const $event = $events.eq(i);
      let eventDate = $event.data('event-date');
      const eventDateParts = eventDate.split('-');
      eventDate = new Date(eventDateParts[0], eventDateParts[1] - 1, eventDateParts[2]);
      if (eventDate.getTime() < d.getTime()) {
        $event.hide();
      }
    });
  },
  initHeroSlider() {
    $('.hero__bg-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      arrows: false,
      fade: true,
      cssEase: 'linear',
    });
  },
  initSlickSlider() {
    $('.card-deck-wrapper').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js